// extracted by mini-css-extract-plugin
export default {"gradientt":"Postcard_gradientt__pmpDl","gradinett":"Postcard_gradinett__6BxM6"};